// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GeWhiteListRequestModel {
    'clientWhiteListId': string;
    'ndc': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GeWhiteListRequestModel>> = [
        {
            "name":     "clientWhiteListId",
            "baseName": "clientWhiteListId",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return GeWhiteListRequestModel.attributeTypeMap;
    }
}
